export default {"src":"/_next/static/media/DKNG.c59a8fea.svg","height":18,"width":18};